import * as rmd from 'material-ui';
import React from 'react';

class Slider extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            value: props[props.propKey]
        };
    }
    componentWillReceiveProps() {}

    componentDidMount = () => {};

    handleChange = (e, val) => {
        this.props.onChange(this.props.propKey, val);
    };

    render() {
        const { value } = this.state;
        return (
            <div>
                <span style={{ paddingTop: '30px', display: 'inline-block' }}>{this.props.label}</span>
                <rmd.Slider step={0.1} defaultValue={value} onChange={this.handleChange} />
            </div>
        );
    }
}

export default Slider;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/Slider.js
 **/